import { Customer } from "../model/customer";
import { useAuth0 } from "@auth0/auth0-react";

export function useCustomerAPI() {
    const { getAccessTokenSilently } = useAuth0();



    /**
     * Get customers with search and pagination (admin only)
     */
    const getCustomers = async (query: string, limit: number = 100, offset: number = 0): Promise<Customer[]> => {
        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_AUD,
            },
        });

        return new Promise<Customer[]>((resolve, reject) => {
            const params = new URLSearchParams();
            params.append("q", query);
            params.append("limit", limit.toString());
            params.append("offset", offset.toString());
            
            fetch(`${process.env.REACT_APP_API_URL}/customer/admin/list?${params.toString()}`, {
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
            }).then((response) => {
                if (response.status === 200) {
                    response.json().then((data: Customer[]) => {
                        resolve(data);
                    });
                } else if (response.status === 403) {
                    reject(new Error("Not authorized to view customers"));
                } else {
                    reject(new Error("Failed to fetch customers"));
                }
            }).catch((error) => {
                reject(error);
            });
        });
    };

    return {
        getCustomers,
    };
}

